import { render, staticRenderFns } from "./HomeChoose.vue?vue&type=template&id=8c51f87a&scoped=true&"
import script from "./HomeChoose.vue?vue&type=script&lang=js&"
export * from "./HomeChoose.vue?vue&type=script&lang=js&"
import style0 from "./HomeChoose.vue?vue&type=style&index=0&id=8c51f87a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c51f87a",
  null
  
)

export default component.exports